export const CUSTOMIZATION_PANEL_TAB_IDS = {
  FILTERS: 'filters',
  COLUMNS: 'columns',
} as const;

export type CustomizationPanelTabId = typeof CUSTOMIZATION_PANEL_TAB_IDS[keyof typeof CUSTOMIZATION_PANEL_TAB_IDS];

interface ICustomizationPanelTab {
  id: CustomizationPanelTabId,
  label: string,
}

export const CUSTOMIZATION_PANEL_TABS: ICustomizationPanelTab[] = [
  { id: CUSTOMIZATION_PANEL_TAB_IDS.FILTERS, label: 'Filters' },
  { id: CUSTOMIZATION_PANEL_TAB_IDS.COLUMNS, label: 'Columns' },
];
